/* wishlist script for wishlistpop AP added */



$('.wishlist_product_button').on('click touchstart ', function(e){

   //alert("click call");
   var product_Id =$(this).data('product-id');
   //e.preventDefault();
   $.fancybox.open({
   	 src  : '#login_form',
     type : 'inline',
     afterShow: function( instance, current ) {
     current_url = window.location.pathname;
       
       /*hd added 01/10/2020*/
       if(current_url.indexOf('?') > -1){
         current_url += '&wk-intent={"action":"addProduct","product":"'+product_Id+'","variant":"'+$('.multi_select').val()+'"}';
         history.pushState("", "", current_url+"");
       }else{
         current_url += '?wk-intent={"action":"addProduct","product":"'+product_Id+'","variant":"'+$('.multi_select').val()+'"}';
       }
       /*hd added 01/10/2020*/
       
     	$('input[name="checkout_url"]').val(current_url);

     }
   });
});

/* This process is for product swath changes added by HD */

/*======= PDP elements update AP added start =========== */
/* purpose: for PDP elements description and review A/B testing  */
//createCookie("PDP_description_elements","");


function PDP_desktop_elements_function(element){
  
  createCookie("PDP_expand_element",element);  

  setTimeout(function(){      
    if(readCookie('PDP_expand_element') == "description"){
      $("summary.description").parent().addClass("is-open").attr("open", "");
    }
    else if(readCookie('PDP_expand_element') == "reviews"){
      $("summary.reviews").parent().addClass("is-open").attr("open", "");
    }
  },1000);
}

function PDP_mobile_elements_function(mobile_element){    
  createCookie("PDP_mobile_expand_element",mobile_element);  
    if(window.matchMedia('(max-width: 767.99px)').matches){
        setTimeout(function(){
          if(readCookie('PDP_mobile_expand_element') == "description"){
            $("summary.description").parent().addClass("is-open").attr("open", "");
          }
          else if(readCookie('PDP_mobile_expand_element') == "reviews"){
            $("summary.reviews").parent().addClass("is-open").attr("open", "");
          }
        },1000);
    }
}

/*======= PDP elements update AP added end =========== */

/*======= Collection review update AP added start 24-02-2023 =========== */
/* purpose: for collection review A/B testing  */

// function review_elements_function(element){
//   createCookie("review_enable",element);  
//   setTimeout(function(){    
//     if(readCookie('review_enable') == "1"){
//       $(".template-collection .collection-listing .product-info .product-block__rating").removeClass("hidden");
//       $(".template-index .product-info .product-block__rating").removeClass("hidden");
//     }
//     else{
//       createCookie("review_enable","0");
//       $(".template-collection .collection-listing .product-info .product-block__rating").addClass("hidden");
//       $(".template-index .product-info .product-block__rating").addClass("hidden");
//     }
//   },1000);
// }
// review_elements_function();  

/* AP commented for display reviews on collection page desktop */
// if (window.matchMedia('(max-width: 767.98px)').matches){
//   $(".template-collection .collection-listing .product-info .product-block__rating").removeClass("hidden");
//   $(".template-index .product-info .product-block__rating").removeClass("hidden");
// }
// else{
//   $(".template-collection .collection-listing .product-info .product-block__rating").addClass("hidden");
//   $(".template-index .product-info .product-block__rating").addClass("hidden");
// }

/*======= Collection review update AP added end 24-02-2023 =========== */

/*======= Main mobile menu update AP added start 27-02-2023 =========== */
// AP commented 30-3-2023 dueto client request
// function product_feed_function(){  
//  setTimeout(function(){
//    if(readCookie('product_feed') == "disable"){
//       $(".navigation__mobile-products").addClass("hidden");
//     }else{
//       $(".navigation__mobile-products").removeClass("hidden");
//     }  
//   },1000);  
//}
/*======= Main mobile menu  update AP added end 27-02-2023 =========== */

/*======= mobile categories menu update AP added start 16-03-2023 =========== */

function mobile_categories_function(){  
 setTimeout(function(){
   if(readCookie('mobile_categories') == "1"){
      $(".mobile-scroll-nav").removeClass("hidden");
    }else{
      $(".mobile-scroll-nav").addClass("hidden");
    }  
  },1000);  
}

/*======= Main mobile menu  update AP added end 16-03-2023 =========== */
if(window.matchMedia('(max-width: 767.98px)').matches){
//  product_feed_function();
 // mobile_categories_function();  
}

// /*======= afterpay msg show only US added by HB 13-Apr-2023 =========== */
// function afterpayMsgHide(){
//     var checkLocalAftrpay = readCookie('localizationtemp');  
//     if($.inArray(checkLocalAftrpay, ['US','us']) == -1){
//       $(".slide_cart_inner .checkout_block_container .cart-policies").css("margin-bottom", "10px");
//       return false;      
//        // $(".price-container").find(".afterpay-paragraph").addClass("hidden");    
//     }else{
//       $(".slide_cart_inner .checkout_block_container .cart-policies").css("margin-bottom", "0px");
//       return true;
//     }
// }

/*======= Pagination txt btn update update AP added start 18-04-2023 =========== */

function pagination_txt_btn_function(){   
    if(window.matchMedia('(max-width: 767px)').matches){
      setTimeout(function(){
       $('.pagination').addClass("animated_arrow");
       $('.pagination_arrow span').removeClass("hidden");      
       //console.log("pagination_txt call");
     },800);
    }else{    
      setTimeout(function(){
       $('.pagination').removeClass("animated_arrow");
       $('.pagination_arrow span').addClass("hidden");        
     },800);  
    }
}
  pagination_txt_btn_function();
/*======= Pagination txt btn update AP added end 18-04-2023 =========== */


/*============ start flash tab msg code ================*/          
          
// function createCookie(name, value, days) {
//   if (days) {
//     var date = new Date();
//     date.setTime(date.getTime() + (60 * 24 * 3600 * 1000));
//     var expires = "; expires=" + date.toGMTString();
//   } else var expires = '';
//   document.cookie = name + "=" + value + expires + "; path=/";
// }

// function readCookie(name) {
//   var nameEQ = name + "=";
//   var ca = document.cookie.split(';');
//   for (var i = 0; i < ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) == ' ') c = c.substring(1, c.length);
//     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
//   }
//   return null;
// }
       
function deleteCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}         
var pageTitle = document.title;
createCookie("site_title", pageTitle);
createCookie("clear_flag", 0);  
createCookie("cart_msg", attentionMessage);
createCookie("beforload_flag", 0);
          
var reset_INT = null;
var three_INT = null;
var first_TO = null;
var init_main_INT = null;
var jqxhr = null;
var index_flash = 0;
var flash_msg = [pageTitle,attentionMessage];       
     
function getFlashMsg(){
  
  var m = "";
  
  if(index_flash == 0){
  	m = pageTitle;
  }else{
    m = readCookie("cart_msg");
  }
  index_flash++;
  index_flash = index_flash>1?0:index_flash;
  
  return m;
  
}
function getCartInTotalItem(){
  
  $.getJSON('/cart.js', function (cart) {
    var cart_result = cart.item_count;
    createCookie("cart_count", cart_result);
    if (cart_result >= 1) {      
      createCookie("cart_msg", attentionMessageCart);
    }else{
      createCookie("cart_msg", attentionMessage);
    }
  });
}
          
$(window).on('beforeunload', function () {
  createCookie("beforload_flag", 1);
  
}); 
document.addEventListener('visibilitychange', function (e) {
  
  clearInterval(init_main_INT);
  init_main_INT = null;
  clearInterval(reset_INT);
  reset_INT = null;
  clearInterval(three_INT);
  three_INT = null;
  clearTimeout(first_TO); // new
  first_TO = null; // new
  
  if (document.hidden && readCookie("beforload_flag") != 1) {
    deleteCookie("site_title");
    createCookie("site_title", 1);
    createCookie("clear_flag", 0);
    init_main();
  } else {
    reset_INT = setTimeout(function () { // New
      deleteCookie("site_title");
      createCookie("site_title", pageTitle);
      createCookie("clear_flag", 1);
      document.title = pageTitle;
    }, 500);
  }
});    
function setPageTitle(flag) { // setTitlePage
  if (readCookie("site_title") != 1) {
    document.title = pageTitle;
  } else {
    document.title = getFlashMsg();
    if (flag) {
      three_second();
    }
  }
}
function three_second() {
  clearInterval(three_INT);
  three_INT = setInterval(function () {
    if (readCookie("site_title") == 1) {
      setPageTitle();
    } else {
      deleteCookie("site_title");
      createCookie("site_title", pageTitle);
      document.title = pageTitle;
    }
  }, 2000); // 3000
}

function firstTime() { // firstTimeTitle
  if (readCookie("site_title") == 1) { // && parseInt(readCookie('interval')) > 3000
    first_TO = setTimeout(function () {
      if (readCookie("site_title") == 1) {
        setPageTitle(1);
        
      } else {
        clearInterval(three_INT); // new
        three_INT = null; // new
        clearTimeout(first_TO); // new
        first_TO = null; // new

        document.title = pageTitle; // for quick title
      }
    }, 28000);
  } else {
    clearInterval(three_INT); // new
    three_INT = null; // new
    clearTimeout(first_TO); // new
    first_TO = null; // new
  }
}
function init_main() {
  init_main_INT = setInterval(function () {
    if (readCookie("clear_flag") == 1) {
      clearInterval(three_INT);
      three_INT = null;
      clearTimeout(first_TO); // new
      first_TO = null; // new
    }

    if (readCookie("site_title") == 1) {
      if (first_TO == null) { // TEMP
        firstTime();
      }
    } else {
      clearInterval(three_INT); // new
      three_INT = null; // new
      clearTimeout(first_TO); // new
      first_TO = null; // new

      document.title = pageTitle; // for quick title
    }
  }, 100);
}
getCartInTotalItem();          
init_main(); // one time init
          
/*======= end flash tab msg code =========== */


var productHandle = "";
var fbSpecialPrice = "";
var blowoutPrice = "";
var mobileSizeDropdown = '';
if(readCookie('campaign-collection') != null)
{
  var campaignArr = [];
  var allCampaign = readCookie('campaign-collection');
  var campaignArr = allCampaign.split(',');
  var utmcampaign = "";
  if($.inArray(utmcampaign,campaignArr) >= 0){
    fbSpecialPrice = 1;
  }
}

if($("body").hasClass( "product" )){
  function refreshStickyBtn(){
    is_sticky_show = true;
    $('.notify_btn').html(" ");
    $('.notify_btn').html($('.notifyme-trigger:not(.custom_quick)').clone());
    var text = $('.product-form .add_to_cart:not(.custom_quick_add)').text();
    var disb_btn = false;
    if(text == "Unavailable" || text == "unavailable"){ disb_btn =true;}
    $('.add_to_cart-small').prop("disabled",disb_btn);
    if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').is(':visible')){
      $('.add_to_cart-small').text(text).removeClass('hidden'); 
    }else{
       $('.add_to_cart-small').text(text).addClass('hidden'); 
    }
  }
}
var template = '';
selectCallback = function(variant, selector,$productDetail = "") {
       $productDetail.find('.notify_btn_submit').prop('disabled', false);
       $productDetail.find('#notify_form_proudct .success_msg').text(" ");
       $productDetail.find('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
       $productDetail.find('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address");
    
          /* added by HB 13-sep-2022 for check model alt length */
          if($productDetail.find('.thumbnail.selected img').length > 0){
            var  model_alt = $productDetail.find('.thumbnail.selected img').attr('alt');
            if(model_alt!=""){            
              model_deail_array = model_alt.split("--");
              if(model_deail_array.length > 1){
                var m_name =  model_alt.split("--")[1];
                /* hd added single or two charecter model name 31/01/23 */
                  m_name = m_name.trim(); 
                  model_name_size = m_name.length;
                  numberCharterNeed =  3 - model_name_size;
                  if(numberCharterNeed > 0){
                    if(numberCharterNeed == 1){
                      m_name = m_name+"‎ ";
                    }else if(numberCharterNeed == 2){
                      m_name = m_name+"‎ "+"‎ ";
                    }
                  }
                 /* hd added single or two charecter model name 31/01/23 */
                
                if(m_name!=""){
                  $productDetail.find(".model_item").addClass('hidden');
                }
                $productDetail.find('.model_item[data-modeinfo="'+m_name+'"]').removeClass('hidden');
              }            
            }            
          }
          
        
        /* hd 25/08/22 added for model info */
  		var $product = $productDetail.find('.product-' + selector.id);
        
        var $notify_form = $productDetail.find('.notify-form-' + selector.id);
        var $productForm = $productDetail.find('form.product_form', $product);
        
        var totalSwatch = 0;
        var count = 0;	
  
      
      	$productDetail.find(".swatch_options .swatch" ).each(function( index ) {
            totalSwatch++;
        });  
        $productDetail.find(".swatch_options .swatch input" ).each(function( index ) {
          if($( this ).is(":checked")){ count++;}
        });
      

  		if (variant) {   
          
          var actualprice = variant.price / 100;
            /*if ( country_code1 == 'US' || country_code1 == 'CA'){
              productShippingNote(shipRate,actualprice);
            }*/
          	
          
            if (variant.inventory_management == null) {
              
                //  console.log("test3============");                                                                                              
                $productDetail.find('.product_stock', $product).html('');
                $productDetail.find('#made-to-order').val('This is a made-to-order item.');
              if(count > 0 )  $('.agree_pod_true', $product).css('display', 'block');
                $productDetail.find('.agree_pod_true', $product).addClass('agree_pod');
                if(count > 0 ) $productDetail.find('.agree_pod_' + selector.id).css('display', 'block');
                $productDetail.find('.agree_pod_' + selector.id).addClass('agree_pod');
                $productDetail.find('.product_stock_not_pod').html('<span class="instock_label"><span style="color:black">Ships next business day*</span></span>');
                $productDetail.find('.product_stock_' + selector.id).html('');
                $productDetail.find('.product_stock_not_pod_' + selector.id).html('<span class="instock_label"><span style="color:black">Ships next business day*</span></span>');
              
            } else if (variant.inventory_management == "shopify" && variant.inventory_policy != "continue") {                   
              
                                             
                  if(totalSwatch == count)
                  {
                    /* as per discuse wiht mam -1 case comment 24/07/2023
                      if varint qty <= 0 and bis tag not found = 'notify me '
                      if varint qty <= 0 and bis tag found = 'sold out '
                      so -1 case comment now after cofirmation with mam.
                    */ 
                    //  if (variant.inventory_quantity <= -1) {
                    //  //  console.log("test8============");
                      
                    //     $productDetail.find('.amazonButton', $product).css('display', 'block');
                    //     /*$productDetail.find('.add_to_cart', $product).addClass('sold_out_product');
                    //     */
                    //     $('.add_to_cart-small.sticky-atc').addClass('sold_out_product');
                    //     $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').addClass('sold_out_product');/*hd add 28-11-22*/
                    //     $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').addClass('sold_out_product');
                
                    //     $productDetail.find('.product_stock', $product).html('');
                    //     $productDetail.find('.product_stock_not_pod').html('');
                    //     $productDetail.find('.product_stock_' + selector.id).html('');
                    //     $productDetail.find('.product_stock_not_pod_' + selector.id).html('');
                    //     $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                    //     $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                
                    //    if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                    //     // console.log("case1");
                    //       //$('.klaviyo-bis-trigger').addClass('hidden');
                    //       $productDetail.find('.notify_form_bis').addClass('hidden');
                    //       $productDetail.find('.notifyme-trigger').addClass('hidden');
                    //       $productDetail.find('.quantity-submit-row__submit').removeClass('hidden');                        
                    //     }
                       
                    //     $productDetail.find('.price-container').removeClass('hidden');

                    // } else 
                    if (variant.inventory_quantity <= 0) {
                     //  console.log("test9============");
                      
                        $productDetail.find('.amazonButton', $product).css('display', 'block');
                        //$productDetail.find('.add_to_cart', $product).addClass('sold_out_product');
                        //$('.add_to_cart-small.sticky-atc').addClass('sold_out_product');

                        $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').addClass('sold_out_product');
                        $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').addClass('sold_out_product');
                
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                        $productDetail.find('.product_stock', $product).html('');
                        $productDetail.find('.product_stock_not_pod').html(' ');
                        $productDetail.find('.product_stock_' + selector.id).html('');
                        $productDetail.find('.product_stock_not_pod_' + selector.id).html(' ');
                      
                      
                      if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                        //console.log("case2");
                        ///$('.klaviyo-bis-trigger').addClass('hidden');
                         
                        $productDetail.find('.notify_form_bis:not(.custom_quick)').addClass('hidden');
                        $productDetail.find('.notifyme-trigger:not(.custom_quick)').addClass('hidden');
                        //$productDetail.find('.quantity-submit-row__submit').removeClass('hidden');
                        $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');
                      }
                      else{

                        //$('.klaviyo-bis-trigger').removeClass('hidden');
                        $productDetail.find('.notify_form_bis:not(.custom_quick)').removeClass('hidden');
                        $productDetail.find('.notifyme-trigger:not(.custom_quick)').removeClass('hidden');
                        $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').addClass('hidden');
                        //$productDetail.find('.quantity-submit-row__submit').addClass('hidden');
                        

                        $productDetail.find(".klaviyo-bis-trigger").click(function(e) {
                          setTimeout(function(){
                            //console.log(backinstock_feature_img);
                            $productDetail.find("#klaviyo-bis-iframe").contents().find('body').find("img").attr('src', '');
                            $productDetail.find("#klaviyo-bis-iframe").contents().find('body').find("img").attr('src', variant.featured_image.src);

                            if(window.matchMedia('(max-width: 375px)').matches){  
                              $productDetail.find("#klaviyo-bis-iframe").contents().find('body').css('overflow','scroll');
                            }
                          },300);
                        });
                      }
                      
                    } else if (variant.inventory_quantity <= 15  || selector.tags.indexOf('low in stock') > -1) {
                      //console.log("test10============");
                      
                      	$productDetail.find('.amazonButton', $product).css('display', 'none');
                        /*$productDetail.find('.add_to_cart', $product).removeClass('sold_out_product');
                        $('.add_to_cart-small.sticky-atc').removeClass('sold_out_product');*/
                       $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').removeClass('sold_out_product');
                       $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').removeClass('sold_out_product');
                       
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');                    
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                        $productDetail.find('.product_stock', $product).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.<span style="color:black">Ships next business day*</span></span>');
                        $productDetail.find('.product_stock_not_pod').html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.<span style="color:black">Ships next business day*</span></span>');
                        $productDetail.find('.product_stock_' + selector.id).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.<span style="color:black">Ships next business day*</span></span>');
                        $productDetail.find('.product_stock_not_pod_' + selector.id).html('<span class="left_instock_label">Hurry! Only ' + variant.inventory_quantity + ' left in stock.<span style="color:black">Ships next business day*</span></span>');

                        if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                          //console.log("case4");
                          //$('.klaviyo-bis-trigger').addClass('hidden');
                          $productDetail.find('.notify_form_bis').addClass('hidden');
                          $productDetail.find('.notifyme-trigger').addClass('hidden');
                          $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');                        
                        }
                         
                        $productDetail.find('.price-container').removeClass('hidden');
                        //$('.notify_txt').addClass('hidden');
                      
						} else {
                        //console.log("test11============");
                      	
                                                                      
                        $productDetail.find('.amazonButton', $product).css('display', 'none');
                        /*$productDetail.find('.add_to_cart', $product).removeClass('sold_out_product');
                        
                        $('.add_to_cart-small.sticky-atc').removeClass('sold_out_product');
                        */
                        $productDetail.find('.agree_pod_true', $product).css('display', 'none');
                        $productDetail.find('#made-to-order').val('');
                        $productDetail.find('.agree_pod_true', $product).removeClass('agree_pod');
                        $productDetail.find('.agree_pod_' + selector.id).css('display', 'none');
                        $productDetail.find('.agree_pod_' + selector.id).removeClass('agree_pod');
                      	$productDetail.find('.product_stock', $product).html('<span class="instock_label"><span style="color:black">Ships next business day*</span></span>');
                        $productDetail.find('.product_stock_not_pod').html('<span class="instock_label"><span style="color:black">Ships next business day*</span></span>');
                        $productDetail.find('.product_stock_' + selector.id).html('<span class="instock_label"><span style="color:black">Ships next business day*</span></span>');
                        
                       /*if(selector.tags.indexOf('bis-hidden') > -1 ||  selector.tags.indexOf('bis_hidden') > -1){
                          //console.log("case6");
                          //$('.klaviyo-bis-trigger').addClass('hidden');
                          $productDetail.find('.notify_form_bis').addClass('hidden');
                          $productDetail.find('.notifyme-trigger').addClass('hidden');
                          $productDetail.find('.quantity-submit-row__submit').removeClass('hidden');                        
                        }*/
                        $productDetail.find('.price-container').removeClass('hidden');                        
                    }
                }
               
          }
          else{}
          $productDetail.find('#quantity').attr('data-price-now',variant.price);
        } else {
                      
            //$('.product_stock', $product).html('');
            $productDetail.find('.product_stock_not_pod').html('');
            /*$('.product_stock_' + selector.id).html('');
            $('.product_stock_not_pod_' + selector.id).html('');*/
         
        }   
        
         if (variant == false) {
           //$('.klaviyo-bis-trigger').addClass('hidden');           
           $productDetail.find('.notify_form_bis').addClass('hidden');
           $productDetail.find('.notifyme-trigger').addClass('hidden');
           $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');           
          $productDetail.find('form[data-product-id='+selector.id+']').find('.quick_txt').addClass('soldout_variant'); //AP Added 4-4-2023
         }
                  
        if (variant && variant.available == true) {
          //$('.klaviyo-bis-trigger').addClass('hidden');
          $productDetail.find('.notify_form_bis').addClass('hidden');
          $productDetail.find('.notifyme-trigger').addClass('hidden');
          $productDetail.find('.quantity-submit-row__submit:not(.custom_quick_row__submit)').removeClass('hidden');
          $productDetail.find('form[data-product-id='+selector.id+']').find('.add_to_cart').removeClass('sold_out_product');
          $('.sticky-options-'+selector.id+' .sticky_option_btn .add_to_cart-small').removeClass('sold_out_product');

          $productDetail.find('form[data-product-id='+selector.id+']').find('.quick_txt').removeClass('soldout_variant'); //AP Added 4-4-2023
          
           if($productDetail.find('.preorder-inventory-msg').attr('data-'+variant.id)) $productDetail.find('.preorder-inventory-msg').show().text('('+$('.preorder-inventory-msg').attr('data-'+variant.id)+'  Pre-Order Left)');
           else $productDetail.find('.preorder-inventory-msg').hide();
        }
        if($("body").hasClass("product")){ refreshStickyBtn();}
      };


$(document).ready(function(){
  var checkLocalization = readCookie('localization');
  if($.inArray(checkLocalization, ['US','CA']) == -1){
    $(".sms_signup-form").remove();
  }
/* sms phone number save, Add By : HB 9-Aug-2022 */ 
  $('#sms_contact_number').focus(function(){
     $('.sms_signup-form .checkbox_container').removeClass('hidden');    
  });
  
$('#sms_contact_number').click(function(){
   $('#sms_contact_number').removeClass('error_note');
    $('.phone_signup__button').removeClass('error_note');
  var sms_btn_txt = 'TXT Me<span class="btn-right-arrow"><svg width="8" height="9" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Arrow</title><path d="m2 1 4 3.5L2 8" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  $('.phone_signup__button').html(sms_btn_txt);
  
    $('#sms_contact_number').attr("placeholder", "Phone Number");
});

$(document).on("keypress paste","#sms_contact_number",function() {
     var smsPhoneNumber = $('#sms_contact_number').val();
    if(smsPhoneNumber.length < 4){
      $('#sms_contact_number').val("+1 ");
      $('.sms_signup-form').find('.checkbox_container').removeClass('hidden');
    }
});

/* footer sms form script start */
  function suppressNonNumericInput(event){
        if( !(event.keyCode == 8                                // backspace
            || event.keyCode == 46                              // delete
            || (event.keyCode >= 35 && event.keyCode <= 40)     // arrow keys/home/end
            || (event.keyCode >= 48 && event.keyCode <= 57)     // numbers on keyboard
            || (event.keyCode >= 96 && event.keyCode <= 105))   // number on keypad
            ) {
                event.preventDefault();     // Prevent character input          
        }
    }
$('#sms_contact_number').keyup(function(){
  var smsPhoneNumber = $('#sms_contact_number').val();  
  $(this).val($(this).val().replace(/(\d{3})\-?(\d{3})\-?(\d{4})/,'($1) $2-$3'));  
});
  
$(".phone_signup__button").click(function(){
  //  $('.sms_signup-form').find('.checkbox_container').removeClass('hidden');
    var isTermsConditions = $('.sms_signup-form').find('input[name="sms_terms_conditions"]').is(':checked');
    if(isTermsConditions == false){
      //document.getElementById("sms_contact_number_error_msg").innerHTML = "Please select terms conditions";
      $("#sms_contact_number_error_msg").removeClass("hidden");
      $('.sms_signup-form .checkbox_container').removeClass('hidden');
    //  console.log(isTermsConditions + " <<");
      return false;
    }else{
       //document.getElementById("sms_contact_number_error_msg").innerHTML = ""; 
      $("#sms_contact_number_error_msg").addClass("hidden");
     // console.log(isTermsConditions + " <<");
    }
  
    var smsPhoneNumber = $('#sms_contact_number').val();
    if(smsPhoneNumber != "" ) { 
      regexp =  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;
      if (!regexp.test(smsPhoneNumber)){
         $('#sms_contact_number').val('');
         $('#sms_contact_number').addClass('error_note');
         $('.phone_signup__button').addClass('error_note');
          //$('.phone_signup__button').html('Text U Later!');
         $('#sms_contact_number').attr("placeholder", "Please enter a valid phone number.");
         return false;
      }  
    }else {      
       $('#sms_contact_number').val('');
       $('#sms_contact_number').addClass('error_note');
       $('.phone_signup__button').addClass('error_note');
       //$('.phone_signup__button').html('Text U Later!');
       $('#sms_contact_number').attr("placeholder", "Please enter mobile."); 
       return false;
    }        
    //document.getElementById("sms_contact_number_success_msg").innerHTML = "";
    $("#sms_contact_number_success_msg").addClass("hidden");
    var checkLocalization = readCookie('localization');
    
    $.ajax({
      type: 'POST',
      dataType: "json",
      data : {"smsPhoneNumber":smsPhoneNumber,"checkLocalization":checkLocalization},
      url: 'https://payments.intotheam.com/private-shopify-app/ajax-allow-origin.php?action=smsSignupSubscribers&shopDomain=iheartraves.myshopify.com',        
      success: function(response){ 
        if(response.error == 0){
          $('.sms_signup-form').find('input[name="sms_terms_conditions"]').prop("checked", false);
          $('.sms_signup-form').find('.checkbox_container').addClass('hidden');
          $('#sms_contact_number').val('');
          $("#sms_contact_number_success_msg").removeClass("hidden");
          
        if(typeof gtag != "undefined"){
          gtag('event', 'Footer Tracking', {'event_category': 'footer','event_label': 'form field submission','value': 'sms sign-up click'});
        }
          setInterval(function() {
            $("#sms_contact_number_success_msg").addClass("hidden");
          }, 5000);
          return true;
        }else{
           $('#sms_contact_number').val('');
           $('#sms_contact_number').addClass('error_note');
           $('.phone_signup__button').addClass('error_note'); 
           //$('.phone_signup__button').html('Text U Later!'); 
           $('#sms_contact_number').attr("placeholder", "Please enter a valid phone number."); 
           return false;
        }
      },
      error: function(exception){   
        return false;
      }
    });
  
});

  $('#notify_form_proudct input[name="notify_accepts_marketing"]').click(function(){
    var isTermsConditionsEmail = $('#notify_form_proudct').find('input[name="notify_accepts_marketing"]').is(':checked');
    if(isTermsConditionsEmail == false){
      $("#notify_form_proudct_error_msg").removeClass("hidden");
      $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
    }else{
      $("#notify_form_proudct_error_msg").addClass("hidden");
      $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', true);
    } 
});
$('.notify_btn_submit').click(function(){
   var isTermsConditionsEmail = $('#notify_form_proudct').find('input[name="notify_accepts_marketing"]').is(':checked');
    if(isTermsConditionsEmail == false){
      $("#notify_form_proudct_error_msg").removeClass("hidden");
      return false;
    }else{
      $("#notify_form_proudct_error_msg").addClass("hidden");
    } 
    var contact_email = $('#notify_form_proudct').find('input[name="contact[email]"]').val();
  
    if(contact_email == "" ) { 
     $('#notify_form_proudct').find('input[name="contact[email]"]').val('');
     $('#notify_form_proudct').find('input[name="contact[email]"]').addClass('error_note');
     $('#notify_form_proudct').find('input[name="contact[email]"]').addClass('error_note');
     $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Please enter a valid email address."); 
      return false;    
    }
    var variant_id = $('.product-purchase-form .original-selector').val(); 
    var product_id = $('.product-purchase-form').data('product-id');
    
     $.ajax({
      type: "POST",
      url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      data: {
        a:"PsjVpw",
        email:contact_email,
        g:"PLtJCA",
        variant:variant_id,
        product:product_id,
        platform:"shopify",
        subscribe_for_newsletter:"true"
      },
      success: function(response) {
        if(response.success){
          $('#notify_form_proudct .success_msg').text("You're in! We'll let you know when it's back");
          $('.notify_btn_submit').prop('disabled', true);
        }
        $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
        $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
        $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);
      },
      error: function(response){   
         $('.notify_btn_submit').prop('disabled', false);
         $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
         $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
        return false;   
      }
    });
  
});

/* footer sms form script end */

/* footer email form script start */

function signupKlaviyoSubscribe(contact_email){
   $.ajax({
      type: "POST",
      url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      data: {
        a:"PsjVpw",
        email:contact_email,
        g:"VbA7jZ",
        //variant:variant_id,
        //product:product_id,
        platform:"shopify",
        subscribe_for_newsletter:"true"
      },
      success: function(response) {
        if(response.success){
          return true;
        }
        /*if(response.success){
          $('#notify_form_proudct .success_msg').text("You're in! We'll let you know when it's back");
          $('.notify_btn_submit').prop('disabled', true);
        }
        $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
        $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
        $('#notify_form_proudct input[name="notify_accepts_marketing"]').prop('checked', false);*/
      },
      error: function(response){   
         return false;
         /*$('.notify_btn_submit').prop('disabled', false);
         $('#notify_form_proudct').find('input[name="contact[email]"]').val(" ");
         $('#notify_form_proudct').find('input[name="contact[email]"]').attr("placeholder", "Email Address"); 
         return false;*/   
      }
    });
} 
  
$('.email_signup-form .signup-form__email').focus(function(){
     $('.email_signup-form .checkbox_container').removeClass('hidden');    
});
$('.email_signup-form .signup-form__email').click(function(){
    $('.email_signup-form .signup-form__email').removeClass('error_note');
    $('.email_signup-form .email_signup__button').removeClass('error_note');
    $('.email_signup-form .signup-form__email').attr("placeholder", "Email Address");
});
/* hd add 03/02/23  */ 
$('#newsletter_page_landing_signup .signup-form__email').focus(function(){
     $('.page_landing_email_signup-form .checkbox_container').removeClass('hidden');    
});
/* hd add 03/02/23  */ 
$('#newsletter_page_landing_signup .signup-form__email').focus(function(){
    //$('.page_landing_email_signup-form .checkbox_container').removeClass('hidden');  
    $('#newsletter_page_landing_signup .signup-form__email').removeClass('error_note');
    $('#newsletter_page_landing_signup .email_signup__button').removeClass('error_note');
    $('#newsletter_page_landing_signup .signup-form__email').attr("placeholder", "Email Address");
});  


  
function ValidateEmail(inputText){
  /*var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if(inputText.match(mailformat)){ return true;}
  else{ return false;}*/
  var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
  return pattern.test(inputText);
}
function MessageSigupform(){
  $('.page_landing_email_signup-form').find('input[name="email_terms_conditions"]').prop("checked", false);
  $('.page_landing_email_signup-form').find('.checkbox_container').addClass('hidden');
  $('.signup-form__email').val('');
  $('.page_landing_email_signup-form').find("#newsletter_success_msg").removeClass("hidden");
  setInterval(function() {
    $('.page_landing_email_signup-form').find("#newsletter_success_msg").addClass("hidden");
  }, 5000);
  return true
}
/* hd add 03/02/23  */ 
$("#newsletter_page_landing_signup").submit(function(e){
    e.preventDefault();
    //var isTermsConditions = $('.signup-form__email').find('input[name="email_terms_conditions"]').is(':checked'); 
    var isTermsConditionsEmail = $('.page_landing_email_signup-form').find('input[name="email_terms_conditions"]').is(':checked'); 
    if(isTermsConditionsEmail == false){
      $('.page_landing_email_signup-form').find("#newsletter_error_msg").removeClass("hidden");
      $('.page_landing_email_signup-form .checkbox_container').removeClass('hidden');
      return false;
    }else{
       //document.getElementById("sms_contact_number_error_msg").innerHTML = ""; 
      $('.page_landing_email_signup-form').find("#newsletter_error_msg").addClass("hidden");
    } 

    var signupEmailVal = $('.signup-form__email').val();
  
    if(signupEmailVal == "" || !ValidateEmail(signupEmailVal)) { 
      $('.page_landing_email_signup-form .signup-form__email').val('');
       $('.page_landing_email_signup-form .signup-form__email').addClass('error_note');
       $('.email_signup_page_landing_button').addClass('error_note');
       $('.page_landing_email_signup-form .signup-form__email').attr("placeholder", "Please enter a valid email address."); 
       return false;    
    }
    $.ajax({
        type: "POST",
        url: 'https://manage.kmail-lists.com/subscriptions/subscribe?a=PsjVpw&g=VbA7jZ',
        data: {
          email:signupEmailVal,
          platform:"shopify",
          subscribe_for_newsletter:"true",
          //a:"PsjVpw",
          //g:"VbA7jZ",
        },
        success: function(response) {
          //console.log('success',success);
          MessageSigupform();
          return true;
        },
        error: function(response){   
          //console.log('error',response);
          if(response.status==0){
            MessageSigupform();
          }
        },
        complate: function(response){   
          //console.log('complate');
          MessageSigupform();
        }
      });
});
/* hd add 03/02/23  */ 
  
$(".email_signup__button").click(function(){
    //var isTermsConditions = $('.signup-form__email').find('input[name="email_terms_conditions"]').is(':checked'); 
    var isTermsConditionsEmail = $('.email_signup-form').find('input[name="email_terms_conditions"]').is(':checked'); 
    if(isTermsConditionsEmail == false){
      $('.email_signup-form').find("#newsletter_error_msg").removeClass("hidden");
      $('.email_signup-form .checkbox_container').removeClass('hidden');
      return false;
    }else{
       //document.getElementById("sms_contact_number_error_msg").innerHTML = ""; 
      $('.email_signup-form').find("#newsletter_error_msg").addClass("hidden");
    } 

    var signupEmailVal = $('#footer_newsletter_signup .signup-form__email').val();
    if(signupEmailVal == "" || !ValidateEmail(signupEmailVal)) { /* hd updated 03/02/23 validation .com */ 
      $('#footer_newsletter_signup .signup-form__email').val('');
       $('#footer_newsletter_signup .signup-form__email').addClass('error_note');
       $('#footer_newsletter_signup .email_signup__button').addClass('error_note');
       $('#footer_newsletter_signup .signup-form__email').attr("placeholder", "Please enter a valid email address."); 
       return false;    
    }
    //$( "form#footer_newsletter_signup" ).submit();
    var dataString =$('form#footer_newsletter_signup').serialize();
    $.ajax({
      type: "POST",
      url: 'https://www.iheartraves.com/contact',
      data: dataString,
      success: function(response) {
          $('.email_signup-form').find('input[name="email_terms_conditions"]').prop("checked", false);
          $('.email_signup-form').find('.checkbox_container').addClass('hidden');
          $('#footer_newsletter_signup .signup-form__email').val('');
          $('.email_signup-form').find("#newsletter_success_msg").removeClass("hidden");
        if(typeof gtag != "undefined"){
          gtag('event', 'Footer Tracking', {'event_category': 'footer','event_label': 'form field submission','value': 'email sign-up click'});
        }
          setInterval(function() {
            $('.email_signup-form').find("#newsletter_success_msg").addClass("hidden");
          }, 5000);
          return true;
      },
       error: function(response){   
          return false;
        }
    });
    
  });
/* footer email form script end */
});

/* Product detail page review click event start AP added 15-3-2023 */
$(".header_section").click(function(e) {
  var top_space = "0";
  
//console.log($(window).width() +"window");

    if(window.matchMedia('(min-width: 960px)').matches){
       top_space = "50";
    }      
    else if(window.matchMedia('(min-width: 768px)').matches){
       top_space = "110";
    }
    else if(window.matchMedia('(min-width: 320px)').matches){
       top_space = "45";
    }
  
 // console.log(top_space+ " << top_space");
    $('.cc-accordion-item__title').parent().removeClass('is-open').removeAttr('open');
      setTimeout(function () {
        if(!$('.cc-accordion-item__title.reviews').parent().hasClass("is-open")) {
           $('.cc-accordion-item__title.reviews').parent().addClass("is-open").attr('open', 'true');
        }
      }, 100);
     
   $('html, body').animate({
        scrollTop: $(".cc-accordion-item__title.reviews").offset().top - top_space
    }, 1500);
});
/* Product detail page review click event end AP added 15-3-2023 */

$(".description").closest(".product-detail-accordion").css({"border": "none"});
$('.scroll_top_container').click(function(){  $("html, body").animate({ scrollTop: 0 }, 600); return false; }); 

if($(window).width() <= 767) {
$("body").find('h5.section-footer__title').addClass("cc_accordion"); 
$("body").find('.section-footer__menu-block__menu').addClass("panel");
  var wind_width ="";
  
  if($("body").hasClass("template-cart")) {
    wind_width =  $(window).width() - 30;   
  }else{
    wind_width =  $(window).width() - 25;
  }
  $(".swatch_scroller").css({"max-width": wind_width});
  
}
var acc = document.getElementsByClassName("cc_accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
  this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
     $(panel).toggle(500);
    } else {      
       $(panel).toggle(500);
    }
  });  
}
  
// $(".swatch.swatch-size").clone().prependTo(".swatch-size-sticky");

/*setTimeout(function(){
 $(".swatch-size-sticky").html($(".swatch.swatch-size").children().clone());
},1000);*/

//$(".swatch-size-sticky").find(".js-option").remove();
 //$(".swatch-size-sticky").find(".opt-btn").removeAttr('id');
  
$(".my_size_chart").click(function(){ 
  $('html, body').animate({
        scrollTop: $(".size_fit").offset().top - 100
    }, 1000);  
  if(!$(".size_fit").parent().hasClass('is-open')){
    	$(".size_fit").trigger("click");    
  }
  
});

var intervalStampedInstagram = setInterval(function(){
    if($('.stamped-instagram-media-block').length > 0 && $(".custom-html").find(".app_title").length > 0){
        if($('.stamped-instagram-media-block').length < 2){
          $(".custom-html").find(".app_title").addClass("hidden");      
        }else{
          $(".custom-html").find(".app_title").removeClass("hidden");      
        }
        clearInterval(intervalStampedInstagram);
    }
},3000);

/* Start AP updated for PDP tab updates 01-02-2023 */
$(".cc-accordion-item").on("click", function () {
  $('.cc-accordion-item').not($(this)).removeClass('is-open').removeAttr('open');
    if ($(this).hasClass("is-open")) {
        $('.cc-accordion-item').not($(this)).removeClass('is-open').removeAttr('open');
    }else{
      setTimeout(function () {
        $(this).addClass("is-open").attr('open');
      }, 100);      
    }
});
if(window.matchMedia('(max-width: 767px)').matches){
  $('.cc-description').removeClass('is-open').removeAttr('open'); 
}
/* end AP updated for PDP tab updates 01-02-2023 */


jQuery(document).ready(function ($) {

  $('.footer_chat_btn').on('click',function(e){
       $('body').find("#chat-button").show();
   });
  
  // $('.collection_description').removeClass('collection_description_before');
  // $('.collection_description').readmore({ collapsedHeight: 55,speed: 500,lessLink: '<a href="#" class="morelink">Less <span class="roted_up"> <i class="fa-solid fa-angle-up"></i> </span></a>',moreLink: '<a href="#" class="morelink">Read More <span class="roted_down"> <i class="fa-solid fa-angle-down"></i> </span></a>',
  //    beforeToggle: function() { if($('.collection_description').attr('aria-expanded') == "true"){ $('.collection_description').removeClass('collectiontoggle');}else{ $('.collection_description').addClass('collectiontoggle'); } } 
  // });
  // if(!$('.collection_description').attr('aria-expanded')){ $('.collection_description').addClass('collectiontoggle'); } 


  if($("body").hasClass( "product" )){
  
    var hidden = $('.swatch-size-sticky');
    // Added code Rk help AP 27-01-23
    // Dueto option show by default on desktop
    if(window.matchMedia('(max-width: 767.98px)').matches){
      $('.swatch-size-sticky').addClass("hidden");
      $('.sticky_option_selector').click(function(event){ 
        //$('.swatch-size-sticky').removeClass("hidden").toggleClass("open");   
        $('.swatch-size-sticky').toggleClass("hidden").toggleClass("open");   
      });
    }
    
    // comment code Rk help AP 27-01-23
    // Dueto option show by default on desktop
    // $('.swatch-size-sticky').addClass("hidden");
    // $('.sticky_option_selector').click(function(event){ 
    //   $('.swatch-size-sticky').removeClass("hidden");
      
    //   if(window.matchMedia('(min-width: 767.99px)').matches){
    //       $('.swatch-size-sticky').animate({"left":"65px","opacity":"1"}, "slow");
    //   }else{
    //       $('.swatch-size-sticky').toggleClass("open");       
    //   }
    // });
    
    jQuery('body').on('click',function(event){
    
    if(!jQuery(event.target).is('.sticky-options .sticky_option_selector, .sticky-options .opt-btn, .sticky-options .option-selector__btns , .sticky-options .opt-label, .sticky-options .opt-label__text, .option-selector-fieldset, .sticky-options .add_to_cart') ) {

      if(jQuery(event.target).is('.sticky-options .add_to_cart-small')){
          product_title = product_title.replace("&#39;","'");
        if(typeof gtag != "undefined")		
        gtag('event', 'Product Page Tracking', {'event_category': 'product page','event_label': 'add to cart sticky','value': product_title});   
        //$(".product-purchase-form .add_to_cart:not(.custom_quick_add)").trigger("click");
        //$('.product-purchase-form').submit();
        $('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').submit();
      }else if(!jQuery(event.target).is('.custom_quick_row__submit .button.button--large.add_to_cart') && jQuery(event.target).is('.product-column-right .button.button--large.add_to_cart')){
         product_title = product_title.replace("&#39;","'");
        if(typeof gtag != "undefined")		
        gtag('event', 'Product Page Tracking', {'event_category': 'product page','event_label': 'add to cart inline','value': product_title});   
        
      }else if(jQuery(event.target).is('.sticky-options .notifyme-trigger')){
        /*$('.notify_form_bis:not(.custom_quick)').find('input[name="notify_accepts_marketing"]').is(':checked');
          $('.notify_form_bis:not(.custom_quick)').find('input[name="contact[email]"]').val();*/
        $('.notify_form_bis:not(.custom_quick) .notify_btn_submit').trigger("click");
        $(window).scrollTop($('.notify_form_bis:not(.custom_quick)').position().top);
      }
    }else if (jQuery(event.target).is('.opt-label__text')) {
      var seleceted_val = jQuery(event.target).closest('.opt-label').data('value');
      $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
      $('.swatch-size-sticky').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
      
    }else if(jQuery(event.target).is('.opt-label')){
        var seleceted_val = jQuery(event.target).data('value');
        $('.product-form .swatch:not(.custom_quick):not(.swatch-color)').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change');
        $('.swatch-size-sticky').find('[value="'+seleceted_val+'"]').prop('checked', true).off().trigger('change'); 
    }
    });
     
    var is_sticky_show = false;
     $(window).scroll(() => {

      var scrollTop     = $(window).scrollTop(),
          elementOffset = $('.mobile_only_mobile_stuff').offset().top,
          distance      = (elementOffset - scrollTop);

      if (distance <= 0){

        if(is_sticky_show==false){
          is_sticky_show = true;
          $('.notify_btn').html(" ");
          $(".sticky-options").removeClass('hide_btn');
          //var sticky_size = $(".swatch.swatch-size:not(.custom_quick)").children().clone();
          //var sticky_size = $('.product-form .swatch.swatch-size:not(.custom_quick)').children().clone();

          var sticky_size = $('.product-form .swatch:not(.custom_quick):not(.swatch-color):not(.swatch-packs)').children().clone();
          var name = sticky_size.find('input').attr("name")+"-ticky";
        
          sticky_size.find('input').attr("name",name);
          sticky_size.find('label').attr("for","");
          $(".swatch-size-sticky").html(sticky_size);
          $('.notify_btn').html($('.notifyme-trigger:not(.custom_quick)').clone());
          $('.swatch-size-sticky').addClass("size-sticky");
          //var text = $('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn):not(.quick_txt)').text();
          var text = $('.product-form .add_to_cart:not(.custom_quick_add)').text();
          var disb_btn = false;
          if(text == "Unavailable" || text == "unavailable"){ disb_btn =true;}
          
          $('.add_to_cart-small').prop("disabled",disb_btn);
          if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').is(':visible')){
            $('.add_to_cart-small').text(text).removeClass('hidden'); 
          }else{
             $('.add_to_cart-small').text(text).addClass('hidden'); 
          }

          if($('.product-form .add_to_cart:not(.custom_quick_add):not(.update-bag-cart-btn)').hasClass('no-variant')){
            $('.add_to_cart-small').addClass('no-variant'); 
          }else{
            $('.add_to_cart-small').removeClass('no-variant'); 
          }
          
          /* AP added 25-01-2023 start*/
          /* Purpose: To remove sticky option selector from single option products*/
          if($('.swatch-size-sticky').find('.option-selector-fieldset').length == 0){
              $(".sticky-options .product_sticky_option").remove();
              $(".sticky-options.bottom_btn").addClass("no_size");              
          }
          /* AP added 25-01-2023 end*/
        }
      } else{
        is_sticky_show = false;
        $(".swatch-size-sticky").children().remove();
        $('.swatch-size-sticky').removeClass("size-sticky");
        $(".sticky-options").addClass('hide_btn');      
      }      
    });
  }
  
});

var announcementBarEnable = setInterval(function(){
  if($("#announcement-bar-with-slider").length > 0){
    var announcement_bar_size = $("#announcement-bar-with-slider").height();
  
    $("body").addClass("announcement-bar-enable");
    $("body").find(".section-header").css({"top":announcement_bar_size});

     $(document).on('click','#announcement-bar-with-slider a',function(){      
       if(typeof gtag != "undefined")		
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar click','value': 'click promo bar'});
    });
    
    //$("body").find(".cart-summary-overlay").css({"top":announcement_bar_size});
    //$("body").addClass("mini_cart_open");
      clearInterval(announcementBarEnable);
  }
 $('.ab-slide-remove').on('click',function(event){
   if(typeof gtag != "undefined"){
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar close','value': 'promo bar closed'});
   }
  $("body").removeClass(".announcement-bar-enable");
  $("body").find(".section-header").css({"top":"0"});
});
}, 2000);

// Added RK 04-10-23 Essential Countdown Timer bar (AP updated for reducing time to apply the class 05-10-23)
var essentialBarEnable = setInterval(function(){
  if($(".essential_countdown_annoucement_bar_wrapper").length > 0){
    var essential_countdown_bar = $(".essential_countdown_annoucement_bar_wrapper").outerHeight();
  
    $("body").addClass("essential_countdown-bar-enable");
    $("body").find(".section-header").css({"top":essential_countdown_bar});

     $(document).on('click','.essential_countdown_annoucement_bar_wrapper a',function(){      
       if(typeof gtag != "undefined")		
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar click','value': 'click promo bar'});
    });
    
    //$("body").find(".cart-summary-overlay").css({"top":essential_countdown_bar});
    //$("body").addClass("mini_cart_open");
      clearInterval(essentialBarEnable);
  }
 $('.essential_countdown_annoucement_bar_wrapper button').on('click',function(event){
   if(typeof gtag != "undefined"){
       gtag('event', 'Promobar Tracking', {'event_category': 'promo bar','event_label': 'promo bar close','value': 'promo bar closed'});
   }
  $("body").removeClass(".essential_countdown-bar-enable");
  $("body").find(".section-header").css({"top":"0"});
});
}, 800);

if($("body").hasClass("template-product")) {
    var ll = $('.description.description-full-bottom div'); 	
    var lh = [];
    var wscroll = 0;
    var wh = $(window).height();

    function update_offsets(){
      $('.description.description-full-bottom div').each(function(){
        var x = $(this).offset().top;
        lh.push(x);
      });
    };

    function lazy() {          
      wscroll = $(window).scrollTop();
      for(i = 0; i < lh.length; i++){
        if(lh[i] <= wscroll + (wh - 100)){
          $('.description.description-full-bottom div').eq(i).addClass('loaded');
          if($('.description.description-full-bottom .ignore-float').height() >$('.description.description-full-bottom').height() && $(".description.description-full-bottom").attr('aria-expanded') == 'true' ){
            var height =$('.description.description-full-bottom .ignore-float').height()+50;
            //           $('.description.description-full-bottom').css('height',height+'px');
          }
        };
      };
    };

      // Page Load
    update_offsets();
    lazy();

    $(window).on('scroll',function(){           
      lazy();
    });
  }
/* Script added for header search functionality AP 29/09/2022 */
if(window.matchMedia('(min-width: 767px)').matches){
  $(".header-account-wrapper").addClass("desktop-only");  
}
$(window).resize(function() {
  if(window.matchMedia('(min-width: 767px)').matches){
    $(".header-account-wrapper").addClass("desktop-only");  
  }else{
   // console.log($(window).width());
    $(".header-account-wrapper").removeClass("desktop-only");
  }
});

/* Script added for Home page section and collection banner AP 29/09/2022 */
$(document).ready(function(){
  var checkLocalization = readCookie('localization');
  
  if($.inArray(checkLocalization, ['US']) == 0 || $.inArray(checkLocalization, ['us']) == 0){
    if($("body").hasClass("collection")){
      $("body").find(".intl_collection_banner").remove();
      $("body").find(".us_collection_banner").removeClass("hidden");  
    }
      
    $("body").find(".int_content").remove();
    $("body").find(".us_content").removeClass("hidden");
  }
  else{

    if($("body").hasClass("collection")){
      $("body").find(".us_collection_banner").remove();
      $("body").find(".intl_collection_banner").removeClass("hidden");  
    }
    
 //   console.log("intl call");    
    $("body").find(".us_content").remove();    
    $("body").find(".int_content").removeClass("hidden");      
  }
});

function lighthouseShow() {
 $('#lighthouse').show(); Lighthouse.showButton();Lighthouse.show(); 
}


// scrolling on filter
function calculateMarginTopForContent(){ 
  var page_header_height = $('.pageheader').height();
  var filter_mobile = $('body');
  var announcementbar = $('#announcement-bar-with-slider').height();
  var essential_countdown_bar = $(".essential_countdown_annoucement_bar_wrapper").outerHeight();
  
  if (announcementbar == undefined){
     var scroll_pageheader = page_header_height;
  }else{
     var scroll_pageheader = ( announcementbar + page_header_height );  
  }  

  if (essential_countdown_bar == undefined){
     var scroll_pageheader = page_header_height;
  }else{
     var scroll_pageheader = ( essential_countdown_bar + page_header_height );  
  }  
  
  $('.container--no-max').find('.utility-bar--sticky-mobile-copy').css("top", scroll_pageheader+ 'px');
}

$(window).scroll(function() {
    if ($(window).width() < 768) {
      var window_scroll = $(window).scrollTop();
       if (window_scroll > 20) {
         $('body').addClass("utility-bar-sticky-mobile-copy-reveal");     
         if($('body').hasClass('collection')){
          
          $('.utility-bar--sticky-mobile-copy .utility-bar__centre .utility-bar__item').text($('.utility-bar .utility-bar__centre .utility-bar__item')[0].outerText);
          
          if($('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').length > 0){
            var count_text = $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
            if(count_text == undefined){
              $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').remove();
            }else{
              $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').html(count_text);
            }
          }else{
            var count_text =  $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
            if(count_text!= undefined ){
              $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item').append('<span class="toggle-btn__count">'+count_text+'</span>');
            }
          }
        }
         
      } else{
         $('body').removeClass("utility-bar-sticky-mobile-copy-reveal");
      }
    }
});


// $(window).scroll(function() {
//     if ($(window).width() < 768) {
//       var window_scroll = $(window).scrollTop();
//        if (window_scroll > 20) {
//           //console.log('test1');
         
//         $('body').addClass("utility-bar-sticky-mobile-copy-reveal");     
        
//         if($('body').hasClass('collection')){
          
//           $('.utility-bar--sticky-mobile-copy .utility-bar__centre .utility-bar__item').text($('.utility-bar .utility-bar__centre .utility-bar__item')[0].outerText);
          
//           if($('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').length > 0){
//             var count_text = $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
//             if(count_text == undefined){
//               $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').remove();
//             }else{
//               $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item .toggle-btn__count').html(count_text);
//             }
//           }else{
//             var count_text =  $('.utility-bar:not(.utility-bar--sticky-mobile-copy) .utility-bar__left .utility-bar__item .toggle-btn__count').html();
//             if(count_text!= undefined ){
//               $('.utility-bar--sticky-mobile-copy .utility-bar__left .utility-bar__item').append('<span class="toggle-btn__count">'+count_text+'</span>');
//             }
//           }
//         }
//       } else{
//          //console.log('test3');
//          $('body').removeClass("utility-bar-sticky-mobile-copy-reveal");
//       }
//     }
// });
$(window).resize(function() {
  if ($(window).width() < 768) {
     calculateMarginTopForContent();
  }
});

setTimeout(function(){
  $('.ab-slide-remove').on( "click", function() { 
    if ($(window).width() < 768) {
      calculateMarginTopForContent();     
    }
  });
}, 1000);

$(window).on( "load", function() { 
  setTimeout(function(){
    if ($(window).width() < 768) {
      calculateMarginTopForContent();     
    }
  }, 1000);
  
var chat_iframe = $('#chat-button').contents();  
    chat_iframe.find("#gorgias-chat-messenger-button").click(function(){
       $('body').find("#chat-button").hide();
    });  
});
